import React, { useEffect, useRef, useState } from 'react'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { twMerge } from 'tailwind-merge'

interface ISlide {
  readonly slideTitle: string | null
  readonly image: {
    readonly gatsbyImage: IGatsbyImageData | null
  } | null
  className?: string
}

interface SlideshowProps {
  readonly slides?:
    | readonly ({
        readonly slideTitle: string | null
        readonly image: {
          readonly gatsbyImage: IGatsbyImageData | null
        } | null
      } | null)[]
    | null
  duration?: number
  transitionDuration?: number
}

const Slide = ({ slideTitle, image, className }: ISlide) => {
  const _className = twMerge(
    'max-w-6xl mx-auto px-4 md:px-0 grid grid-cols-1 md:min-h-none md:grid-cols-[300px_52px_auto] lg:grid-cols-[400px_152px_auto] md:max-h-[32rem] items-center',
    className,
  )

  return (
    <div className={_className}>
      {slideTitle && (
        <p
          className={`slide__text relative z-10 -my-8 mb-16 md:mb-0 md:my-0 mx-4 order-2 md:order-1 md:mx-0 md:col-start-1 md:col-end-3 md:row-start-1 md:row-end-2 px-8 py-4 md:px-12 md:py-8 bg-secondary leading-snug md:leading-snug lg:leading-snug rounded shadow-2xl shadow-card text-white text-3xl md:text-4xl lg:text-6xl`}
          dangerouslySetInnerHTML={{ __html: slideTitle }}
        />
      )}

      {image && image.gatsbyImage && (
        <GatsbyImage
          className={`slide__image relative order-1 md:order-2 md:col-start-2 md:col-end-4 md:row-start-1 md:row-end-2 rounded`}
          image={image.gatsbyImage}
          alt=""
        />
      )}
    </div>
  )
}

export const Slideshow2 = ({
  slides,
  duration,
  transitionDuration,
}: SlideshowProps) => {
  const timer = useRef<ReturnType<typeof setTimeout>>(null)
  const [index, setIndex] = useState<number>(0)
  const slide = slides![index]

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current)
    timer.current = setTimeout(
      () => {
        let newIndex = index + 1

        if (newIndex >= slides?.length!) {
          newIndex = 0
        }

        setIndex(newIndex)
      },
      duration ? duration * 1000 : 3000,
    )

    return () => clearTimeout(timer.current!)
  })

  return (
    <TransitionGroup appear={true} className="relative flex justify-center w-screen min-h-[24rem] md:min-h-[none]">
      <CSSTransition
        in={true}
        appear={false}
        key={index}
        timeout={700}
        classNames="slide"
      >
        <Slide
          slideTitle={slide?.slideTitle!}
          image={slide?.image!}
        />
      </CSSTransition>
    </TransitionGroup>
  )
}
